import { usePages } from "@shapeable/ui";
import { isSenseMakingPage } from "../types";
import { transformPage } from "../utils/transforms";

export const useSenseMakingPages = () => (
  usePages().filter(isSenseMakingPage).map(transformPage)
);
